import {
	Box,
	Button,
	Card,
	CardContent,
	Container,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { SERVICE_TYPES } from "src/Helpers/utils/constants";
import { muiStyles } from "src/Utils/Styles";
import { useApiMutation } from "src/hooks/useApiMutation";

const useStyles = muiStyles;

interface Props {
	handleClose: () => void;
}

const CreatePayableItem = ({ handleClose }: Props) => {
	const classes = useStyles();

	const { register, handleSubmit, reset, control } = useForm();

	const { mutate: createItem, isPending } = useApiMutation<
		Record<string, string>,
		void
	>({
		method: "POST",
		endPoint: `/api/admin/payment-items`,
		invalidateQueries: ["PayableItems"],
	});

	const handleCreateItem = (inputs: Record<string, string>) => {
		createItem(inputs);
		handleClose();
		reset();
	};

	return (
		<div>
			<Container sx={{ mt: 4 }} maxWidth="lg">
				<Card>
					<CardContent>
						<Box
							component="form"
							onSubmit={handleSubmit(handleCreateItem)}
							sx={{
								mt: 1,
							}}
						>
							<div className="form-grid">
								<TextField
									margin="normal"
									required
									fullWidth
									{...register("name")}
									label="Service Item Name"
									id="name"
									name="name"
									variant="filled"
									type="text"
									className={classes.inputText}
									InputProps={{ classes }}
								/>
							</div>

							<TextField
								margin="normal"
								required
								fullWidth
								id="amount"
								label="Service item BDT amount"
								{...register("amount", { min: 0 })}
								type="number"
								variant="filled"
								className={classes.inputText}
								InputProps={{ classes }}
							/>
							<TextField
								margin="normal"
								required
								fullWidth
								id="discount"
								label="Service item BDT discount"
								{...register("discount", { min: 0 })}
								type="number"
								variant="filled"
								className={classes.inputText}
								InputProps={{ classes }}
							/>

							<FormControl
								sx={{ marginTop: 2 }}
								fullWidth
								required
							>
								<InputLabel id="type">Type</InputLabel>
								<Controller
									control={control}
									name="type"
									rules={{
										required: "Account Type is required!",
									}}
									render={({ field }) => (
										<Select
											labelId="type"
											label="Service Type"
											{...field}
										>
											{SERVICE_TYPES.map((service) => (
												<MenuItem value={service}>
													{service.toUpperCase()}
												</MenuItem>
											))}
										</Select>
									)}
								/>
							</FormControl>

							<Button
								type="submit"
								fullWidth
								variant="contained"
								disableElevation
								sx={{
									mt: 3,
									mb: 2,
									py: 1,
								}}
							>
								{isPending
									? "Creating..."
									: "Create Service Item"}
							</Button>
						</Box>
					</CardContent>
				</Card>
			</Container>
		</div>
	);
};

export default CreatePayableItem;
